module.exports = __webpack_public_path__ + "05f638efe94b90300ecff5a1417fc4bb.jpg";